import { Suspense } from 'react';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/config/queryClient';
import { AuthenticationProvider } from '@/contexts/Authentication';
import { ToastProvider } from '@/contexts/Toast';
import { SocketConnectionProvider } from '@/contexts/SocketConnection';
import { router } from '@/routes';
import { PageLoading } from '@/components';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthenticationProvider>
          <SocketConnectionProvider>
            <Suspense fallback={<PageLoading />}>
              <RouterProvider router={router} />
            </Suspense>
          </SocketConnectionProvider>
        </AuthenticationProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
